import axios from "axios";
import { toast } from "react-toastify";
import Config from "../Config";
import { useMutation } from "react-query"

const useDeal = ({ token, onSuccessCallback } = {}) => {

  // API + Mutation combined
  const {
    mutate: createDeal,
    isLoading: createDealLoading,
  } = useMutation({
    mutationFn: async (values) => {
      const response = await axios.post(
        `${Config.apiUrl}/deal/create`,
        values,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    },

    onSuccess: (data) => {
      toast.success(data?.msg || "Deal created successfully");

      if (onSuccessCallback) {
        onSuccessCallback(data);
      }
    },

    onError: (err) => {
      toast.error(err?.response?.data?.msg || "Failed to create deal");
    },
  });

  return {
    addDealMutate: createDeal,
    addDealLoading: createDealLoading,
  };
};

export default useDeal;